import * as React from 'react';
import Helmet from 'react-helmet';
import {styled, mq} from '../../utils';
import ForgotPasswordForm from '../../containers/ForgotPasswordForm';
import {Main} from '../../components/AuthLayout';

const PageTitle = styled('h1')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: 38,
  marginBottom: 19,
  [mq('laptop')]: {
    fontSize: 42,
    marginBottom: 21
  },
  [mq('desktop')]: {
    fontSize: 50,
    marginBottom: 25
  }
}));

export default class ForgotPassword extends React.Component<{}, {}> {
  public render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Forgot your password</title>
        </Helmet>
        <Main narrow={true} style={{marginTop: 200}}>
          <PageTitle>Forgot your password</PageTitle>
          <ForgotPasswordForm />
        </Main>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword/ForgotPassword.tsx